import { Label } from "../../../components/Label";
import { Radio } from "../../../components/Radio";
import { Message } from "../../../components/Message";

const SelectDrinkSizeStep = ({ category, mountPayload }) => {
  const handle = (e) => {
    mountPayload({ default_sizes: e.target.value === 'true' });
  };

  return (
    <>
      {category.sizes.length > 1 && (
        <>
          <Label>Onde estes tamanhos serão cadastrados?</Label>
          <Radio
            family="drink-size"
            value={true}
            checked={category.default_sizes}
            className="mb-15"
            onChange={(value) => handle(value)}
          >
            Tamanhos iguais neste categoria
          </Radio>
          <Radio
            family="drink-size"
            value={false}
            checked={category.default_sizes}
            className="mb-20"
            onChange={(value) => handle(value)}
          >
            Tamanhos diferentes por produto
          </Radio>

          {category.default_sizes ? (
            <Message text="Tamanhos iguais para todos os produtos cadastrados nesta categoria / A definição dos tamanhos se aplicará de forma padrão a todos os produtos cadastrados." />
          ) : (
            <Message text="Tamanhos específicos para cada produto cadastrado nesta categoria / A definição dos tamanhos será por produto, no cadastramento do mesmo." />
          )}
        </>
      )}
    </>
  );
};

export default SelectDrinkSizeStep;
